export default function Config() {

   let config = {
      env: {
         name: null,
         localhost: null,
         development: null,
         production: null
      },
      endpoints: {
         api: null
      }
   };

   config.env.name           = process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : 'localhost';
   config.env.localhost      = (config.env.name === 'local');
   config.env.localhost      = (config.env.name === 'localhost');
   config.env.development    = (config.env.name === 'dev');
   config.env.development    = (config.env.name === 'development');
   config.env.production     = (config.env.name === 'prod');
   config.env.production     = (config.env.name === 'production');

   if (config.env.localhost) {
      config.endpoints.api   = 'http://api.dionysos-events.local';
   }

   else if (config.env.development) {
      config.endpoints.api   = 'http://api.dionysos-events.local';
   }

   else if (config.env.production) {
      config.endpoints.api   = 'https://api.dionysos-events.com';
   }

   return config;
}



// WEBPACK FOOTER //
// ./src/Config.js